module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/85ec1ef9814530e2979840e6597a4fad.svg";